import $ from 'jquery';
// import "slick-carousel";
// import TweenMax from "gsap";

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  scrollAnime();
});
$(window).on("load", function() {
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity", "1");
    scrollAnime();
  });
  $(".nav_link[data-id='" + $("body").data("id") + "']").addClass("active");

});

// スクローラー
$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

// フェードイン アニメーション
function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    fadeH = 200
    ;

  $('.fadein, .slidein').each(function() {
    var targetPosition = $(this).offset().top;

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : 200;

    if (topWindow > targetPosition - windowHeight + (fadeH) || $(this).data("first") == 1) {
      $(this).addClass($(this).data("fadein"));
    }
  });
}
